import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CheckEmailExist, CheckUsernameExist, SendVerifyCode, VerifyCode, VerifyEmailCode } from "../api/auth";
import { SendVerifyCodeAction } from "../api/models/SendVerifyCodeAction";
import { ContactType } from "../api/models/ContactType";
import { showConsoleError } from "../util/ConsoleMessage";

interface onBoardingState {
  email: string;
  mobile: string;
  emailVerificationCode: string;
  mobileVerificationCode: string;
  newPassword: string;
  username: string;
}


const initialState: onBoardingState = {
  email: "",
  mobile: "",
  emailVerificationCode: "",
  mobileVerificationCode: "",
  newPassword: "",
  username: ""
};



export const onBoardingSlice = createSlice({
  name: "on-boarding",
  initialState: initialState,
  reducers: {
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    
    setEmailVerificationCode: (state, action: PayloadAction<string>) => {
      state.emailVerificationCode = action.payload;
    },

    setMobile: (state, action: PayloadAction<string>) => {
      state.mobile = action.payload;
    },

    setMobileVerificationCode: (state, action: PayloadAction<string>) => {
      state.mobileVerificationCode = action.payload;
    },


    setPassword: (state, action: PayloadAction<string>) => {
      state.newPassword = action.payload;
    },

    setUsername: (state, action: PayloadAction<string>) => {
      state.username = action.payload;
    }
  },
});


export const checkEmailExist = (email: string) => {
  return async (dispatch: any) => {
    try {
      await CheckEmailExist(
        email
      );
      dispatch(onBoardingActions.setEmail(email));
    } catch (error) {
      throw error;
    }
  };
};

export const sendVerifyCode = (action: SendVerifyCodeAction, contactType: ContactType, contact: string) => {
  return async (dispatch: any) => {
    try {
      await SendVerifyCode(
       action,
        contactType,
        contact
      );
      if (contactType == ContactType.sms) {
        dispatch(onBoardingActions.setMobile(contact));
      } else {
        dispatch(onBoardingActions.setEmail(contact));
      }
    } catch (error) {
      const errorObj = { "errorObj": error, "type": contactType }
      showConsoleError(`sendVerifyCode---${errorObj}`)

      throw errorObj;
    }
  };
};

export const verifyEmailCode = (pin: string) => {
  return async (dispatch: any, getState: any) => {
    const state = getState();
    const email = state.onBoarding.email;
    try {
      await VerifyEmailCode(
        email,
        pin
      );
      dispatch(onBoardingActions.setEmail(email));
      dispatch(onBoardingActions.setEmailVerificationCode(pin));
    } catch (error) {
      throw error;
    }
  };
};


export const verifyCode = (pin: string) => {
  return async (dispatch: any, getState: any) => {
    const state = getState();
    const mobile = state.onBoarding.mobile;
    try {
      await VerifyCode(
        SendVerifyCodeAction.register,
        ContactType.sms,
        mobile,
        pin
      );
      dispatch(onBoardingActions.setMobileVerificationCode(pin));
    } catch (error) {
      throw error;
    }
  };
};


export const checkUsernameExist = (username: string) => {
  return async (dispatch: any) => {
    try {
      await CheckUsernameExist(
        username
      );
      dispatch(onBoardingActions.setUsername(username));
    } catch (error) {
      throw error;
    }
  };
};

export const onBoardingActions = onBoardingSlice.actions;

export default onBoardingSlice.reducer;